export default Backbone.Model.extend({
  initialize: function () {
    this.set("status_date", new Date(this.get("status_date")));
  }
});